// Annual, half-open calendar windows. Dates are evaluated in Istanbul, never
// in the device timezone.
export const CALENDAR_THEMES = Object.freeze([
  { id: "republic-day", start: 1029, end: 1105, label: "29 Ekim Cumhuriyet Bayramı" },
  { id: "ataturk-remembrance", start: 1110, end: 1111, label: "10 Kasım Atatürk’ü anma" },
]);

export function resolveCalendarTheme(now = new Date()) {
  if (!Number.isFinite(now.getTime())) return null;
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Istanbul", month: "2-digit", day: "2-digit",
  }).formatToParts(now);
  const value = Number(parts.find((p) => p.type === "month").value) * 100
    + Number(parts.find((p) => p.type === "day").value);
  return CALENDAR_THEMES.find(({ start, end }) => start <= end
    ? value >= start && value < end
    : value >= start || value < end) || null;
}

// Next Istanbul midnight, calculated from zoned wall-clock parts. Re-evaluate
// hourly as well to recover from wall-clock changes while the tab stays open.
export function calendarRefreshDelay(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Istanbul", hourCycle: "h23",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  }).formatToParts(now);
  const get = (type) => Number(parts.find((p) => p.type === type).value);
  const elapsed = ((get("hour") * 60 + get("minute")) * 60 + get("second")) * 1000 + now.getMilliseconds();
  return Math.min(3600000, ...[32700000, 32760000, 86400000].filter((boundary) => boundary > elapsed).map((boundary) => boundary - elapsed));
}

// Site-wide appearance choice; never stored in personal theme/lite preferences.
export function resolveConfiguredCalendarTheme(mode, now = new Date()) {
  const theme = mode === "auto" ? resolveCalendarTheme(now)
    : CALENDAR_THEMES.find((item) => item.id === mode) || null;
  if (theme?.id !== "ataturk-remembrance") return theme;
  return { ...theme, phase: remembrancePhase(now) };
}

export function remembrancePhase(now) {
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Istanbul", hourCycle: "h23", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }).formatToParts(now);
  const date = Number(parts.find(p => p.type === "month").value) * 100 + Number(parts.find(p => p.type === "day").value);
  if (date < 1110) return "before";
  if (date > 1110) return "after";
  const minute = Number(parts.find(p => p.type === "hour").value) * 60 + Number(parts.find(p => p.type === "minute").value);
  return minute < 545 ? "before" : minute < 546 ? "silence" : "after";
}
